import { TagPickerField } from "entities/tag/ui/tag-picker-field";
import { BaseUrlParamsFilter } from "./base-url-params-filter";
import { Field } from "formik";

export const TagUrlParamFilter = ({ queryParamName }: { queryParamName: string }) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName} >
        <Field fullWidth name={queryParamName} component={TagPickerField} clearable={true} compactTags={true}/>
    </BaseUrlParamsFilter>
  );
}
